export default __webpack_public_path__ + "static/media/MicrosoftTeams-image (1).00b96ba6.png";